import { actions } from './actions'

const initialState = {
  data: {},
}

export default function topicReducer(state = initialState, action) {
  switch (action.type) {
    case actions.LOAD_TOPIC_RESULT:
      return { ...state, data: action.payload.data }
    case actions.RESET_TOPIC:
      return { ...state, data: {} }
    default:
      return state
  }
}
